import { FhsAxios } from "../../services/axios";
import { hasItBeenLoaded } from "@/helpers/loading";
import moment from "moment";
export default {
  state: {
    assetDynamics: null,
    assetDynamicsDateRange: [
      moment()
        .subtract(1, "year")
        .format("DD.MM.YYYY"),
      moment()
        .subtract(1, "months")
        .format("DD.MM.YYYY")
    ]
  },
  actions: {
    fetchAssetDynamics({ commit, getters, state }, payload = null) {
      commit("unsetAssetDynamics");
      // Прерываем выполение, если список уже загружен
      if (hasItBeenLoaded(state.assetDynamics)) {
        return;
      }
      let prepared_data = {
        bdate: state.assetDynamicsDateRange[0] || null,
        edate: state.assetDynamicsDateRange[1] || null
      };
      let data = payload || prepared_data;
      // Создаем базовый url для запроса
      let url = "user/balance-by-day";
      // Если пользователь - VIP и пользователь выбрал определенного брокера, добавляем в запрос ID брокера (получаем данные только по выбранному брокеру)
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }
      FhsAxios.post(url, data).then(response => {
        let assetDynamics;
        try {
          assetDynamics = response.data.result.balance;
        } catch (e) {
          assetDynamics = [];
        }
        commit("setAssetDynamics", assetDynamics);
      });
    },
    clearAssetDynamics({ commit }) {
      commit("unsetAssetDynamics");
    }
  },
  mutations: {
    setAssetDynamics(state, assetDynamics) {
      state.assetDynamics = assetDynamics;
    },
    unsetAssetDynamics(state) {
      state.assetDynamics = null;
    },
    setAssetDynamicsDateRange: (state, payload) =>
      (state.assetDynamicsDateRange = payload)
  },
  getters: {
    assetDynamics(state) {
      return state.assetDynamics || [];
    },
    isAssetDynamicsLoading(state) {
      return state.assetDynamics === null;
    },
    getAssetDynamicsDateRange: state => state.assetDynamicsDateRange
  }
};
